let classMapId = 0;

// Counts seen classes to identify uniqueness (in at least a single instance).
// This is needed because when using a normal object to create the mapping, the
// class (ie: its name and constructor) are cast to a string, which may conflict.
export default class ClassMap {
  private classes: Record<number, unknown>;
  private field: string;
  private nextId: number;

  constructor() {
    this.nextId = 1;
    this.classes = {};
    this.field = `_honk_clsid_${classMapId++}`;
  }

  get<Instance>(cls: {
    new (...args: any[]): Instance;
    [property: string]: any;
  }) {
    return this.classes[cls[this.field]] as Instance | undefined;
  }

  set<Instance>(
    cls: { new (...args: any[]): Instance; [property: string]: any },
    instance: Instance,
  ) {
    if (!cls[this.field]) {
      cls[this.field] = this.nextId++;
    }
    this.classes[cls[this.field]] = instance;
  }
}
